(function () {
  if (window.pzQuickSizeLoaded) return;
  window.pzQuickSizeLoaded = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pz-quick-size__btn');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = btn.closest('.pz-quick-size');
    var label = wrap.querySelector('.pz-quick-size__label');
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { id: Number(btn.dataset.variantId), quantity: 1 };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }
    btn.classList.add('is-loading');
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { label.textContent = res.description || 'Sorry, that size is sold out'; return; }
        label.textContent = 'Added to bag ✓';
        if (cart && cart.renderContents) { cart.renderContents(res); }
        else { window.location = window.routes.cart_url; }
      })
      .catch(function () { window.location = window.routes.cart_url; })
      .finally(function () { btn.classList.remove('is-loading'); });
  });
})();
